import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './subtextColor.module.scss';

interface SubtextColorProps {
    variant?: 'primary' | 'secondary';
    className?: string;
}

const SubtextColor = ({ variant, className, children }: PropsWithChildren<SubtextColorProps>) => {
    const color: string = classNames(
        variant === 'secondary' ? styles['subtext-color--secondary'] : styles['subtext-color'],
    );

    return <div className={classNames(color, className)}>{children}</div>;
};

export default SubtextColor;
